import { NumField, Field } from "@/components/Fields";

const Mode = ({ value, onChange }) => (
  <Field label="Optimise">
    <div className="flex h-9 rounded-md border border-slate-700 overflow-hidden" data-testid="bom-mode-toggle">
      {[["item", "Item by item"], ["project", "Whole project"]].map(([v, l]) => (
        <button key={v} type="button" data-testid={`bom-mode-${v}`} onClick={() => onChange(v)}
          className={`px-3 text-xs font-mono uppercase tracking-wider transition-colors ${value === v ? "bg-cyan-500 text-slate-950" : "text-slate-400 hover:bg-slate-800"}`}>{l}</button>
      ))}
    </div>
  </Field>
);

const Stat = ({ label, value, testid, warn }) => (
  <div className="px-3 py-1.5 rounded-md border border-slate-700 bg-[#0B0F19]" data-testid={testid}>
    <div className="font-mono text-[10px] uppercase tracking-wider text-slate-500">{label}</div>
    <div className={`font-mono text-sm ${warn ? "text-amber-300" : "text-cyan-300"}`}>{value}</div>
  </div>
);

export const BomSettingsBar = ({ raw, s, setS, plan }) => (
  <div className="flex flex-wrap items-end gap-3 p-3 rounded-lg border border-slate-800 bg-[#0d1220]" data-testid="bom-settings">
    <div className="w-28"><NumField label="Bar length mm" testid="bom-bar-input" min={500} value={raw.bar ?? s.bar} onChange={(v) => setS({ bar: v })} /></div>
    <div className="w-24"><NumField label="Saw cut mm" testid="bom-kerf-input" min={0} value={raw.kerf ?? s.kerf} onChange={(v) => setS({ kerf: v })} /></div>
    <div className="w-28"><NumField label="End trim mm" testid="bom-trim-input" min={0} value={raw.trim ?? s.trim} onChange={(v) => setS({ trim: v })} /></div>
    <Mode value={s.mode} onChange={(mode) => setS({ mode })} />
    <div className="w-20"><NumField label="GST %" testid="bom-gst-input" min={0} value={raw.gst ?? s.gst} onChange={(v) => setS({ gst: v })} /></div>
    <div className="ml-auto flex gap-2">
      <Stat label="Bars" value={plan.bars} testid="bom-stat-bars" />
      <Stat label="Stock m" value={(plan.stock / 1000).toFixed(1)} testid="bom-stat-stock" />
      <Stat label="Waste" value={`${plan.waste}%`} testid="bom-stat-waste" warn={plan.waste > 15} />
    </div>
  </div>
);
